import { gql } from '@apollo/client';

export const GET_TRACK_STATISTICS = gql`
  query GetTrackStatistics(
    $trackCode: String!, 
    $analysisTypeId: Int = 1, 
    $meetingLimit: Int, 
    $trackCondition: String,
    $dayType: String
  ) {
    trackStatistics(
      trackCode: $trackCode, 
      analysisTypeId: $analysisTypeId, 
      meetingLimit: $meetingLimit, 
      trackCondition: $trackCondition,
      dayType: $dayType
    ) {
      trackName
      trackCode
      state
      topPickPerformance {
        trackName
        trackCode
        state
        winners
        races
        winPercentage
        roi
      }
      valuePickPerformance {
        trackName
        trackCode
        state
        winners
        races
        winPercentage
        roi
      }
      allPicksPerformance {
        trackName
        trackCode
        state
        winners
        races
        winPercentage
        roi
      }
      recentMeetings {
        meetingDate
        dayOfWeek
        totalRaces
        topPickWinners
        topPickWinPercentage
        topPickROI
        allPicksWinners
        allPicksWinPercentage
        valuePickWinners
        valuePickWinPercentage
        valuePickROI
        trackCondition
        meetingUrl
        meetingDateFormatted
      }
      averageWinnerSP {
        averagePrice
        totalWinners
      }
      overallSuccess {
        totalWinners
        totalRaces
        successRate
      }
      biggestWinner {
        horseName
        trackName
        date
        price
      }
    }
  }
`;
